class ThemePerformance {
  constructor(metricPrefix) {
    this.metricPrefix = metricPrefix
  }

  createStartingMarker(benchmarkName) {
    const metricName = `${this.metricPrefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`)
  }

  measureFromEvent(benchmarkName, event) {
    const metricName = `${this.metricPrefix}:${benchmarkName}`
    performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    })

    performance.mark(`${metricName}:end`)

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`)
  }

  measureFromMarker(startMarker) {
    const metricName = startMarker.name.replace(/:start$/, '')
    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(metricName, startMarker.name, endMarker.name)
  }

  measure(benchmarkName, callback) {
    const metricName = `${this.metricPrefix}:${benchmarkName}`
    performance.mark(`${metricName}:start`)

    callback()

    performance.mark(`${metricName}:end`)

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    )
  }
}

export const cartPerformance = new ThemePerformance('cart-performance')
